
import { useState, useEffect } from 'react';

export default function ComingSoonBanner() {
  const [isVisible, setIsVisible] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsVisible(false);
    }, 5000);

    return () => clearTimeout(timer);
  }, []);

  if (!isVisible) return null;

  return (
    <div className="fixed top-24 left-1/2 transform -translate-x-1/2 z-50 animate-slide-down">
      <div className="bg-gradient-to-r from-[#9B4C9A] to-[#FF9BC8] text-white px-8 py-4 rounded-full shadow-2xl flex items-center gap-3 animate-float">
        <div className="w-3 h-3 bg-white rounded-full animate-pulse"></div>
        <p className="font-bold text-lg whitespace-nowrap">
          🎉 Fluffy Pets is Now Open!
        </p>
        <button
          onClick={() => setIsVisible(false)}
          className="ml-2 w-6 h-6 flex items-center justify-center hover:bg-white/20 rounded-full transition-colors cursor-pointer"
        >
          <i className="ri-close-line text-lg"></i>
        </button>
      </div>
    </div>
  );
}
